if(!customElements.get("deferred-media")) {
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.poster = this.closest('section').querySelector(`#Deferred-Poster-Modal-${this.dataset.mediaId}`);
      this.videoControls = this.querySelector('.js-video-controls');
      this.videoElement = null;
      this.autoplay = this.dataset.autoplay === 'true';
  
      if (!this.poster) return;

      if (this.autoplay) {
        this.setupAutoplayObserver();
      } else {
        this.poster.addEventListener('click', this.loadContent.bind(this));
      }
  
      this.videoControls && this.addVideoControlListeners();
    }

    setupAutoplayObserver() {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.loadContent(false); // Load video with autoplay
            observer.unobserve(this.poster); // Unobserve after content is loaded
          }
        });
      }, { threshold: 0.2 });
    
      observer.observe(this.poster);
    }     
  
    loadContent(focus = true) {
      this.pauseAllMedia();
  
      this.posterHeight = this.poster.clientHeight + 'px';
      this.poster.remove();
  
      if (this.getAttribute('loaded')) return;
  
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
  
      this.setAttribute('loaded', true);
  
      this.videoElement = this.appendChild(content.querySelector('video, iframe'));
  
      this.videoElement.style.height = this.posterHeight; // Setting the iframe/video height equal to the image poster to avoid layout shift
  
      if (focus) this.videoElement.focus();
      if (this.videoElement.nodeName == 'VIDEO' && this.videoElement.getAttribute('autoplay')) {
        // force autoplay for safari
        this.videoElement.play();
      }

      this.updateDatasetValues('play');

      // Add ended event listener for the video element
      this.videoElement.addEventListener('ended', () => {
        this.updateDatasetValues('pause'); // Set paused to true when video ends
      });
    }
  
    addVideoControlListeners() {
      const controlActions = {
        'data-icon-play': () => this.controlMedia('play'),
        'data-icon-pause': () => this.controlMedia('pause'),
        'data-icon-unmuted': () => this.controlMedia('mute'),
        'data-icon-muted': () => this.controlMedia('unmute')
      };
  
      Object.entries(controlActions).forEach(([selector, action]) => {
        this.videoControls.querySelector(`[${selector}]`)?.addEventListener('click', action);
      });
    }
  
    controlMedia(action) {
      try {
        action === 'play' ? this.videoElement.play() : action === 'pause' ? this.videoElement.pause() :
        action === 'mute' ? (this.videoElement.muted = true) : (this.videoElement.muted = false);

        this.updateDatasetValues(action);
      } catch (err) {
        console.error('Error controlling media:', err);
      }
    }

    updateDatasetValues(action) {
      if (action === 'play') this.dataset.paused = false;
      if (action === 'pause') this.dataset.paused = true;
      if (action === 'mute') this.dataset.muted = true;
      if (action === 'unmute') this.dataset.muted = false;
    }
  
    pauseAllMedia() {
      document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('video').forEach((video) => video.pause());
      document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }
  }
  
  customElements.define('deferred-media', DeferredMedia);
}